<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  data() {
    return {
      user_info: [],
      
      roles: [],
      departments: [],

      resetPassModal: false,
      emailChangeWarning: false,
      updateUserModal: false,
    }
  },

  watch: {
    resetPassModal(val) {
      if (val === true) {
        this.$refs.resetPassPopup.openPopup();
      }
    },

    emailChangeWarning(val) {
      if (val === true) {
        this.$refs.emailChangePopup.openPopup();
      }
    },

    updateUserModal(val) {
      if (val === true) {
        this.$refs.updateUserPopup.openPopup();
      }
    },
  },

  mounted() {
    this.setUserInfo();
    this.allRoles();
    this.allDepartments();
  },

  methods: {
    ...mapActions("app", ["destroyToken"]),
    logOut() {
      this.destroyToken({ user_id: this.$user.user_id })
        .then(res => {
          this.$notify('success', res.data.messageName);
          localStorage.clear();
          sessionStorage.clear();
        })
        .finally(() => {
          this.$router.push("/login");
        })
    },
    
    ...mapActions("settings", [
      "getUsers",
      "updateUser",
      "getRoles",
      "getDepartments",
      "getCompaniesByUser",
      "getUserInfo",
      "sendResetPasswordMail"
    ]),
    setUserInfo() {
      this.user_info = structuredClone(this.$user);
    },
    
    allRoles() {
      const params = {
        role_id: this.$user.role_id,
      };
      this.getRoles(params)
        .then((res) => {
          this.roles = res.data;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },

    allDepartments() {
      const params = {
        is_deleted: false,
      };
      this.getDepartments(params)
        .then(res => {
          this.departments = res.data;
        })
        .catch(err => {
          console.log(err);
        })
    },

    openUpdateUser() {
      if (sessionStorage.getItem('user_email') != this.user_info.email) {
        this.emailChangeWarning = true;
      } else {
        this.updateUserModal = true;
      }
    },

    onCloseUpdate() {
      if (this.emailChangeWarning) {
        this.emailChangeWarning = false;
        this.logOut();
      } else if (this.updateUserModal) {
        this.updateUserModal = false;
      }
    },
    sendUpdateUser() {
      const params = {
        user_id: this.user_info.user_id,
        body: {
          firstname: this.user_info.firstname,
          surname: this.user_info.surname,
          user_department_id: this.user_info.user_department_id,
          role_id: this.user_info.role_id,
          email: this.user_info.email
        }
      };

      this.updateUser(params)
        .then(res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          sessionStorage.setItem('user_email', this.user_info.email);
          this.onCloseUpdate();
        })
    },

    updateUserInfo() {
      const endpoint = "/api/auth/updateuser";
      const reqBody = this.$sortDifference(this.$myData, this.user_info);
      const dynamicID = this.user_info.user_id;

      this.$updateRequest(endpoint, reqBody, dynamicID) // BUG: partial update on this endpoint makes user password not work anymore.
        .then(res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          sessionStorage.setItem('user_email', this.user_info.email);
          this.onCloseUpdate();
        })
    },

    openResetPassModal() {
      this.resetPassModal = true;
    },
    onCloseResetPass() {
      this.resetPassModal = false;
    },
    sendResetPassword() {
      const params = {
        reset: false,
        email: this.$user.email
      };

      this.sendResetPasswordMail(params)
        .then(res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.onCloseResetPass();
        })
    },

    // notifications //

    contactUs() {
      if (this.$timerDone.value) {
        this.$toast.open({
          message: i18n.t('userProfile.contactUs'),
          type: "info",
          duration: 5000,
          dismissible: false,
        });
        this.$timerDone.value = this.$startTimer(5000, this.$timerDone);
      }
    }
  },
}
</script>

<template>
  <div class="user-profile-page">
    <div class="user-profile-card">
      <div class="profile-element-border element-header">
        <label for="input">
          {{ $t('userProfile.name') }}
        </label>
        <input type="text" v-model="user_info.firstname" maxlength="70">
      </div>

      <div class="profile-element-border element-header">
        <label for="input">
          {{ $t('userProfile.lastName') }}
        </label>
        <input type="text" v-model="user_info.surname" maxlength="70">
      </div>

      <div class="profile-element-border element-header">
        <label for="input">
          {{ $t('registerForm.modalİnputs.department') }}
        </label>
        <select name="input" v-model="user_info.user_department_id">
          <option v-for="item in departments" :value="item.user_department_id" :key="item.user_department_id">
            {{ item.user_department_name }}
          </option>
        </select>
      </div>

      <div class="profile-element-border element-header">
        <label for="input">
          {{ $t('registerForm.modalİnputs.roleId') }}
        </label>
        <div class="input-like-field" style="background-color: whitesmoke !important;">
          {{ user_info.role_name }}
        </div>
      </div>

      <div style="width: 100%;">
        <div class="email-header element-header">
          {{ $t('userProfile.email') }}
        </div>
        <div class="profile-element-border element-header email-field" @click="contactUs">
          {{ user_info.email }}
        </div>
      </div>

      <div class="profile-element-border element-header" style="margin-top: 1em;">
        <div style="
                font-style: italic;
                font-weight: bold;
                font-size: 1.25em;
                margin-bottom: .5em;
              ">
          {{ $t('userProfile.password') }}
        </div>
        <button class="sust-btn sust-btn-blue" @click="openResetPassModal">
          {{ $t('userProfile.resetPass') }}
        </button>
      </div>

      <button @click="openUpdateUser" class="sust-btn sust-btn-green" style="float: right; margin: .75em .25em;">
        {{ $t('userProfile.save') }}
      </button>
    </div>

    <sust-popup
      ref="resetPassPopup"
      :title="$t('userProfile.resetPass')" 
      size="sm"
      @onHide="onCloseResetPass"
      @ok="sendResetPassword"
    >
      {{ $t('userProfile.confirmPass') }}
    </sust-popup>


    <sust-popup
      ref="emailChangePopup"
      :title="$t('userProfile.warning')"
      size="sm" 
      @onHide="onCloseUpdate"
    >
      {{ $t('userProfile.confirmEmail') }}
    </sust-popup>

    <sust-popup
      ref="updateUserPopup"
      :title="$t('userProfile.updateUser')" 
      size="sm" 
      @onHide="onCloseUpdate()"
      @ok="updateUserInfo()"
    >
      {{ $t('userProfile.confirmUpdate') }}
    </sust-popup>
  </div>
</template>

<style lang="scss" scoped>
.user-profile-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  overflow-y: auto;
}

.email-header {
  padding-left: .5em;
  padding-bottom: .5em;
}

.email-field {
  padding-left: .5em !important;
  margin-bottom: 1em;

  border-radius: .3em;

  transition: all 350ms;
  cursor: not-allowed;

  &:hover {
    background-color: white;
  }
}

.element-header {
  color: var(--sustainfinity-navy);
  font-weight: 600;
}

.user-profile-card {
  width: 35%;
  padding: .5em;
  background-color: #f5f5f5;
  box-shadow: 0 .1em .5em .25em gray;
  border-radius: 1rem;
}

.profile-element-border {
  padding: .25rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  >* {
    width: 100%;
  }

  >label {
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 1.2em;
    text-align: center;
    color: black;
  }

  >select,
  input,
  textarea,
  .input-like-field {
    padding: .25em;
    border: 0 !important;
    outline: thin solid lightgray;
    border-radius: .25em;

    &:focus {
      outline: thin solid black !important;
    }
  }
}
</style>

<style>
.contact-us-link {
  color: #023047 !important;
  font-weight: bold !important;
}

.contact-us-link:hover {
  color: black;
  text-decoration: underline;
}
</style>